import type { AppearanceConfig } from '@meilleurtaux/form-factory'

interface Urls {
  home: string
  forms: string
}

type Environment = 'dev' | 'recette' | 'integration' | 'production'

const defaultUrl: Record<Environment, Urls> = {
  production: {
    home: 'https://www.meilleurtaux.com',
    forms: 'https://apps.meilleurtaux.com',
  },
  recette: {
    home: 'https://appsrecette.mass-tech.io',
    forms: 'https://appsrecette.mass-tech.io',
  },
  integration: {
    home: 'https://appsintegration.mass-tech.io',
    forms: 'https://appsintegration.mass-tech.io',
  },
  dev: {
    home: 'https://appsrecette.mass-tech.io',
    forms: 'https://appsrecette.mass-tech.io',
  },
}

const lcaUrls: Record<Environment, Urls> = {
  production: {
    home: 'https://www.lecomparateurassurance.com',
    forms: 'https://forms.lecomparateurassurance.com',
  },
  recette: {
    home: 'https://recette.lecomparateurassurance.com',
    forms: 'https://formsrecette.lecomparateurassurance.com',
  },
  integration: {
    home: 'https://integration.lecomparateurassurance.com',
    forms: 'https://formsintegration.lecomparateurassurance.com',
  },
  dev: {
    home: 'https://recette.lecomparateurassurance.com',
    forms: 'https://formsrecette.lecomparateurassurance.com',
  },
}

export function getUrl(env: Environment, target: 'forms', appearance?: AppearanceConfig): string
export function getUrl(env: Environment, target: 'home', appearance?: AppearanceConfig): string
export function getUrl(
  env: Environment,
  target: 'home' | 'forms',
  appearance?: AppearanceConfig,
): string {
  // Cas particulier des urls personnalisées
  if (target === 'home' && appearance?.homePageUrl) {
    return appearance.homePageUrl.replace(/\/$/, '') // On s'assure que l'url ne se termine pas par un slash
  }

  if (target === 'forms' && appearance?.tarificationUrl) {
    return appearance.tarificationUrl.replace(/\/$/, '') // On s'assure que l'url ne se termine pas par un slash
  }

  // Détection du domaine courant
  const currentUrl = globalThis.location.href
  let url = ''
  // Si l'url est sur le domaine "lecomparateurassurance.com", on utilise forms.lecomparateurassurance.com pour forms et www.lecomparateurassurance.com pour home
  if (currentUrl.includes('lecomparateurassurance.com')) {
    url = lcaUrls[env][target]
  }
  // Si on a trouvé une url, on l'utilise
  if (url) return url
  // Sinon on utilise les urls de meilleurtaux
  return defaultUrl[env][target]
}
